;(function () {
  angular
    .module('contrast.user.settings')
    .controller('UserAddCtrl', UserAddCtrl)

  function UserAddCtrl(
    $scope,
    $location,
    permissions,
    logger,
    preferencesService,
    UserFactory,
    groupsApiConfig,
    GlobalFactory,
    OrganizationFactory,
    AuthFactory,
    RoleFactory,
    sharedGroupService,
    UserService,
    ErrorService,
    GlobalService,
    FeaturesService,
    AUTH_MODE,
    PREFERENCE_PROPERTIES
  ) {
    'ngInject'

    var organization = undefined
    var readOnlySelected = false
    var validFreemiumRoles = ['admin']

    angular.extend($scope, {
      isEOP: permissions.isEOP,
      model: {
        existing: false,
        unselectUser: true,
        enabled: false,
        passwordvalid: true,
        isExternalAuth: false,
        skipUserValidation: false
      },
      select: {
        groups: [],
        date_formats: [],
        time_formats: [],
        time_zones: [],
        roles: [],
        roleOnChange: function (role) {
          $scope.user.role = role
        }
      },
      user: {
        org_management: true,
        enabled: true,
        groups: [],
        protect: UserService.isFreemiumOrganization()
      }
    })

    angular.extend($scope, {
      save: save,
      getExternalUsers: getExternalUsers,
      populateForm: populateForm,
      findImportUsers: findImportUsers,
      clearExistingUser: clearExistingUser,
      clearNewUser: clearNewUser,
      onRemoveGroup: onRemoveGroup,
      onSelectGroup: onSelectGroup,
      isOrgProtectionEnabled: UserService.isOrganizationProtectionEnabled,
      isAssignRoleViaSSOEnabled: isAssignRoleViaSSOEnabled,
      isSaveButtonDisabled: isSaveButtonDisabled
    })

    function init() {
      _getDateFormats()
      _getTimeFormats()
      _getTimeZones()
      _getOrganizationInfo()
      _getRoles()

      _getAddExistingUserProperty()
      _getOrganizationalAccessGroups()
      _getAuthMode()

      var label = GlobalService.getAttributeLabel()
      if (angular.isUndefined(label) || 0 === label.length) {
        $scope.model.label = 'Email'
      } else {
        $scope.model.label = label
      }
    }

    function _getAuthMode() {
      return AuthFactory.getAuthMode().then(
        function (response) {
          var data = response.data
          $scope.model.isExternalAuth =
            data.auth_mode == AUTH_MODE.mode.AD ||
            data.auth_mode == AUTH_MODE.mode.LDAP
          $scope.model.skipUserValidation = response.data.skip_user_validation
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getDateFormats() {
      return GlobalFactory.getDateFormats().then(
        function (response) {
          $scope.select.date_formats = response.data.date_formats
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getTimeFormats() {
      return GlobalFactory.getTimeFormats().then(
        function (response) {
          $scope.select.time_formats = response.data.time_formats
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getTimeZones() {
      return GlobalFactory.getTimeZones().then(
        function (response) {
          $scope.select.time_zones = response.data.timezones
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getOrganizationInfo() {
      return OrganizationFactory.getOrganization().then(
        function (response) {
          organization = response.data.organization
          $scope.user.date_format = organization.date_format
          $scope.user.time_format = organization.time_format
          $scope.user.time_zone = organization.timezone
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getOrganizationalAccessGroups() {
      return groupsApiConfig.getGroupsBase().then(
        function (response) {
          $scope.select.groups = response.data.groups
          sharedGroupService.formatOrganizationGroups($scope.select.groups)

          if (UserService.isFreemiumOrganization()) {
            $scope.user.groups = [$scope.select.groups[0]]
          }
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getAddExistingUserProperty() {
      return preferencesService
        .getBooleanValue(PREFERENCE_PROPERTIES.USERS_IMPORT_USER)
        .then(function (preferenceValue) {
          $scope.model.enabled = preferenceValue
        })
    }

    function _getRoles() {
      return RoleFactory.getRoles().then(function (response) {
        $scope.select.roles = response.data.groups
        if (UserService.isFreemiumOrganization()) {
          $scope.select.roles = $scope.select.roles.filter(function (role) {
            return validFreemiumRoles.indexOf(role.name) !== -1
          })
        }
      }, ErrorService.processError)
    }

    function getExternalUsers(val) {
      $scope.loadingLocations = true
      return UserFactory.getGlobalExternalUsers(val).then(
        function (response) {
          $scope.loadingLocations = false
          return response.data.users
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function isAssignRoleViaSSOEnabled() {
      return FeaturesService.isSplitFeatureFlagOn(
        'PROD-3575_assign_user_role_via_sso'
      )
    }

    function isSaveButtonDisabled() {
      // If the ff is enabled, the role is assigned via SSO, so we don't need to validate the role because it will be hidden in the UI
      if (isAssignRoleViaSSOEnabled()) {
        return $scope.form.$invalid || $scope.form.$pristine
      }

      return $scope.form.$invalid || $scope.form.$pristine || !$scope.user.role
    }

    function save() {
      $scope.model.saving = true

      var savePromise

      if ($scope.model.existing) {
        savePromise = UserFactory.addExistingUser(
          UserService.createImportUser($scope.user)
        )
      } else {
        let roleValue = 4 //4 Is view role, only because the role is assigned via SSO
        if (!isAssignRoleViaSSOEnabled()) {
          roleValue =
            typeof $scope.user.role === 'number'
              ? $scope.user.role
              : $scope.user.role.group_id
        }

        var form = {
          username: $scope.user.username,
          first_name: $scope.user.first_name,
          last_name: $scope.user.last_name,
          time_zone: $scope.user.time_zone,
          date_format: $scope.user.date_format,
          time_format: $scope.user.time_format,
          enabled: $scope.user.enabled,
          api_only: $scope.user.api_only,
          role: roleValue
        }

        var groups = []
        _.each($scope.user.groups, function (group) {
          groups.push(group.group_id)
        })
        form.groups = groups

        //if organization has protect enabled, add protect flag
        if ($scope.isOrgProtectionEnabled()) {
          form.protect = $scope.user.protect
        }

        savePromise = UserFactory.addUser(form)
      }

      savePromise.then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $location.path(UserService.buildUrl('/settings/users'))
        },
        function (response) {
          ErrorService.processError(response)
          $scope.model.saving = false
        }
      )
    }

    function populateForm(item) {
      $scope.model.unselectUser = false
      $scope.model.user = item.user_uid
      $scope.user.first_name = item.first_name
      $scope.user.last_name = item.last_name

      $scope.user.username = item.user_uid
      $scope.user.enabled = item.enabled
      $scope.user.api_only = item.api_only
    }

    function findImportUsers(query) {
      return UserFactory.getExternalUsers('preferences', query).then(
        function (response) {
          var data = response.data
          return data.users
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function clearExistingUser() {
      $scope.model.unselectUser = true
      $scope.model.user = ''

      _clear()
    }

    function clearNewUser() {
      $scope.user.date_format = organization.date_format
      $scope.user.time_format = organization.time_format
      $scope.user.time_zone = organization.timezone

      $scope.user.first_name = ''
      $scope.user.last_name = ''

      _clear()
    }

    function _clear() {
      $scope.user.username = ''
      $scope.user.enabled = true
      $scope.user.api_only = false
      $scope.user.groups = []
    }

    function onSelectGroup(item) {
      if (item.readonly && readOnlySelected) {
        $scope.user.groups = _.filter($scope.user.groups, function (group) {
          return !group.readonly || group.group_id == item.group_id
        })
      } else if (item.readonly && !readOnlySelected) {
        readOnlySelected = true
      }
    }

    function onRemoveGroup(item) {
      if (item.readonly) {
        readOnlySelected = false
      }
    }

    init()
  }
})()
